var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13.868,
    viewBox: "0 0 15 13.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -19.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.716,25.082a.469.469,0,0,0,.663,0l.606-.606a.469.469,0,0,0,0-.663l-.606-.606h8.341a1.408,1.408,0,0,1,1.406,1.406.7.7,0,0,0,.7.7H14.3a.7.7,0,0,0,.7-.7,3.285,3.285,0,0,0-3.281-3.281H3.378l.606-.606a.469.469,0,0,0,0-.663l-.606-.606a.469.469,0,0,0-.663,0L.069,22.1a.235.235,0,0,0,0,.332Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.285,288.234a.469.469,0,0,0-.663,0l-.606.606a.468.468,0,0,0,0,.663l.606.606H3.281A1.408,1.408,0,0,1,1.875,288.7a.7.7,0,0,0-.7-.7H.7a.7.7,0,0,0-.7.7,3.285,3.285,0,0,0,3.281,3.281h8.341l-.606.606a.468.468,0,0,0,0,.663l.606.606a.469.469,0,0,0,.663,0l2.647-2.647a.235.235,0,0,0,0-.332Z",
    transform: "translate(0 -260.808)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.d9d6d234a246196788d2896941e8af26.svg";
export { ForwardRef as ReactComponent };